var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}]},[(_vm.showNavbar)?_c('navbar',{on:{"toggleDrawer":_vm.toggleDrawer}}):_vm._e(),_c('router-view')],1),(_vm.showFooter)?_c('close-app-footer'):_vm._e(),(_vm.isLoading)?_c('loading-page'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }